import { gicOptInStatusResources } from '@atlassian/jira-router-resources-global-issue-create-switch/src/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useIsModernGlobalIssueCreatePreferred = () =>
	useResource(gicOptInStatusResources).data?.gicOptInStatus?.isEnabled ?? false;
